import React, { useRef, useState } from "react";
import {
  Grid,
  Select,
  Button,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const AuditTrail = () => {
  const [msisdn, setMsisdn] = useState("");
  const [data, setData] = useState<any[]>([]);
  const agGridRef = useRef<AgGridReact | null>(null);
  const [features, setFeatures] = useState<Number>(0);
  const [action, setAction] = useState<Boolean>(false);

  const columnDefs: ColDef[] = [
    {
      field: "TimeStamp",
      headerName: "TimeStamp",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "Plan_Name",
      headerName: "PlanName",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "Action",
      headerName: "ActionType",
      filter: true,
      sortable: true,
      resizable: true,
    },

    {
      field: "Performed_By",
      headerName: "PerformedBy",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "msisdn",
      headerName: "Msisdn",
      filter: true,
      sortable: true,
      resizable: true,
    },
  ];
  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };

  const handleGetBundles = async () => {
    setData([]);
    toast.dismiss();
    if (msisdn.trim().length > 9 && features !== 0) {
      setAction(true);
      getAuditTrail();
    } else {
      toast.error("Please enter valid input.");
    }
  };
  const formatTimestamp = (timestamp: string) => {
    if (!timestamp) return "";

    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${year}-${month}-${day} ${hours
      .toString()
      .padStart(2, "0")}:${minutes}${ampm}`;
  };

  const getAuditTrail = async () => {
    await axiosInterceptorInstance
      .get(`/dashboard/AuditTrail?Msisdn=${msisdn.trim()}&Feature=${features}`)
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (!apiresponse.Data || apiresponse.Data.length == 0) {
          toast.error("Record not found.");
          setData([]);
        } else {
          const formattedData = apiresponse.Data?.map((item: any) => ({
            ...item,
            TimeStamp: formatTimestamp(item.TimeStamp),
          }));
          setData(formattedData);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Audit Trail</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="Msisdn"
                variant="outlined"
                value={msisdn}
                onChange={(e) => setMsisdn(e.target.value)}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  style={{ background: "#fff", padding: " 0 5px" }}
                >
                  Features
                </InputLabel>
                <Select
                  value={features}
                  defaultValue={features}
                  onChange={(e) => setFeatures(Number(e.target.value))}
                  style={{ minWidth: 150 }}
                >
                  <MenuItem value={0}>Choose Feature</MenuItem>
                  <MenuItem value={1}>Auto Top-up</MenuItem>
                  <MenuItem value={2}>Auto Renewal</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>

      {data?.length > 0 && (
        <div style={{ height: 540, width: "100%", marginTop: 16 }}>
          <div className="ag-theme-alpine">
            <AgGridReact
              ref={agGridRef}
              paginationPageSize={10}
              pagination={true}
              domLayout="autoHeight"
              rowData={data}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              enableCellTextSelection={true}
            ></AgGridReact>
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default AuditTrail;
